module.exports = __webpack_public_path__ + "img/liucheng1.8e18f7cd.png";